import React                           from 'react';
import {
  Route,
  RouteComponentProps,
  Switch,
  Prompt
}                                      from 'react-router-dom';
import {
  Observe,
  WatcherTypeFn
}                                      from 'rewire-core';
import { WithStyle }                   from 'rewire-ui';
import Routes                          from '../Routes';
import sideTogglePanelModel            from '../side-navigation/SideTogglePanelModel';
import { Theme }                       from '../utility/styles';
import { pageState, hasChanges }       from './DefaultSettingsView';
import RouteSettingsPage               from './RouteSettingsPage';
import settingsPanelModel              from './SettingsPanelModel';
import {
  ISettingsBase,
  isGroup,
  makeLink,
}                                      from './SettingsModel';
import { SettingsOrGroup }             from './SettingsOrGroup';
import SettingsPage                    from './SettingsPage';
import SettingsDialog                  from './SettingsDialog';
import { withStyles }                  from '../utility/styles';


const styles = (theme: Theme) => ({
  root: {
    width: '100%',
    display: 'flex',
    flexDirection: 'column',
    height: '100%',
    minHeight: '125px',
  },
  settingsContainer: {
    display: 'flex',
    flex: '1 1 auto',
    flexDirection: 'column',
    width: '100%',
    transition: theme.transitions.create(['width'], {
      easing: theme.transitions.easing.sharp,
      duration: theme.transitions.duration.shorter,
    }),
  },
});

interface ISettingsProps { history: any; location: any; match: any; }

function mapSettings<T>(fn: (settings: ISettingsBase) => T, _settings?: ISettingsBase[], result: T[] = []) {
  const s = _settings || settingsPanelModel.settings;
  for (const settings of s) {
    if (isGroup(settings)) {
      mapSettings(fn, settings.group, result);
      continue;
    }
    result.push(fn(settings));
  }
  return result;
}

type SettingsProps = WithStyle<ReturnType<typeof styles>, ISettingsProps & RouteComponentProps<any>>;

const SettingsSidePanelContents = React.memo((props: any) => (
  <>
  <Observe render={() => (
    <>
    {settingsPanelModel.settings.map(s => <SettingsOrGroup key={s.id} settings={s} classes={props.classes} refreshToggle={settingsPanelModel.settingsPanelRefreshToggle} />)}
    </>
  )} />
  <SettingsDialog />
  </>
));

class Settings extends React.PureComponent<SettingsProps> {
  watchUdts: WatcherTypeFn;

  constructor(props: SettingsProps) {
    super(props);
  }

  componentDidMount() {
    settingsPanelModel.load();
    pageState.loaded = true;
    sideTogglePanelModel.SidePanelContent = SettingsSidePanelContents;
    pageState.__settings?.editor && pageState.__settings.activate();
  }

  componentWillUnmount() {
    sideTogglePanelModel.SidePanelContent = null;
    if (pageState.__settings?.editor) {
      pageState.__settings?.deselect();
    }
  }

  render() {
    const {classes} = this.props;

    return <Observe render={() => {
      // const _unused = pageState.loaded;
      return (<div className={classes.root}>
        <Switch>
          {mapSettings(s => <Route key={s.id} exact path={makeLink(s)} component={() => <RouteSettingsPage settings={s} pageState={pageState} />}/>)}
          <Route exact path={Routes.Settings} component={() => <RouteSettingsPage settings={null} pageSettings={pageState.__settings} />} />
        </Switch>
        <Observe>{() => <Prompt when={hasChanges()} message={_location => `There are unsaved changes for ${pageState.__settings?.selectedItem?.name}.\nDo you wish to return and save your changes?`} />}</Observe>
        <SettingsPage settings={pageState.__settings} />
      </div>);
    }} />;
  }
}

export default withStyles<ISettingsProps>(styles, Settings);
